// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "sitechromepublisher/" + (chunkId === 543 ? "translations" : chunkId) + "." + {"422":"4793ee1f0a2f302d46dd","543":"040ba1906aeb2c9abbbd"}[chunkId] + ".js";
};